"use client";

import { useEffect } from "react";
// import * as Sentry from "@sentry/nextjs";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("global-error", error);

  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8">
      <h1 className="text-3xl font-semibold text-text-900 mb-2">
        Something went wrong
      </h1>
      <p className="text-text-700 mb-6">
        An unexpected error occurred. Please try again.
      </p>
      <button
        onClick={() => reset()}
        className="text-primary-600 underline"
        type="button"
      >
        Try again
      </button>
    </div>
  );
}
